export default __webpack_public_path__ + "d6893fc43d8875ccaff1eafe523ebc71.svg";